"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _slicedToArray2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/slicedToArray.js"));
var _toConsumableArray2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.object.values");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _components = require("@/components");
var _role = require("@/api/data/role");
var _roleList = require("@/api/data/roleList");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Role',
  components: {
    PageInfo: _components.PageInfo
  },
  data: function data() {
    return {
      pagination: {
        page: 1,
        limit: 20,
        total: 100
      },
      querySelectOptions: [],
      searchForm: {
        app_name: undefined,
        state: undefined
      },
      adChannelSelectOptions: [],
      packageSelectOptions: [],
      menuSelectOptions: [],
      catalogOptions: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      activeName: 'newFirst',
      checkedList: [],
      dialogVisible: false,
      listData: [],
      isEdit: false,
      packageAll: false,
      adChannelAll: false,
      catalogAll: false,
      dataForm: {
        name: '',
        permission: {
          project_id: [],
          app_id: [],
          new_package_id: [],
          package_id: [],
          ad_group: [],
          menu: []
        }
      },
      rules: {
        app_name: [{
          required: true,
          message: '请输入应用名称',
          trigger: 'blur'
        }],
        app_domain: [{
          required: true,
          message: '请输入应用域名',
          trigger: 'blur'
        }],
        state: [{
          required: true,
          message: '请输入状态',
          trigger: 'blur'
        }],
        des: [{
          required: true,
          message: '请输入描述',
          trigger: 'blur'
        }]
      },
      stateList: [{
        label: '启用',
        value: 1
      }, {
        label: '禁用',
        value: 2
      }]
    };
  },
  activated: function activated() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(page) {
        var params, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (page) this.pagination.page = page;
              params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), this.pagination);
              _context.next = 4;
              return (0, _role.getRoleList)(params);
            case 4:
              res = _context.sent;
              this.listData = res.data.list;
              this.pagination.total = res.data.total;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    // 转换应用菜单数据格式
    generateMenuSelectOption: function generateMenuSelectOption(initialData) {
      var customIndex = 0;
      var initData = function initData(data) {
        data.forEach(function (item) {
          var children = item.children,
            id = item.id,
            app_name = item.app_name,
            menu_name = item.menu_name,
            app_id = item.app_id,
            action = item.action;
          item.name = app_name || menu_name;
          item.id = "".concat(app_id || id, "_").concat(action || customIndex);
          customIndex++;
          if (children) initData(children);
        });
      };
      initData(initialData);
      return initialData;
    },
    /* 初始化相关内容 */init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              Promise.all([this.fetchData(), (0, _role.getRoleSelection)(), (0, _roleList.getAdChannel)(), (0, _roleList.getPackage)(), (0, _roleList.getMenu)(), (0, _roleList.getCatalogList)()]).then(function (res) {
                _this.querySelectOptions = res[1].data;
                _this.adChannelSelectOptions = res[2].data;
                _this.packageSelectOptions = res[3].data;
                _this.catalogOptions = _this.formatCatalogData(res[5].data);
                _this.menuSelectOptions = _this.generateMenuSelectOption(Object.values(res[4].data));
              }).catch(function (err) {
                _this.$message.error(err.msg);
                throw new Error(err.msg);
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    initTree: function initTree(data) {
      if (!this.adChannelAll) {
        this.$refs.adChannelTree.setCheckedKeys(data.permission.ad_group);
      }
      this.$refs.menuTree.setCheckedKeys(this.dataForm.permission.menu);
    },
    addRoleBtn: function addRoleBtn() {
      var _this2 = this;
      this.dialogVisible = true;
      this.isEdit = false;
      this.packageAll = false;
      this.adChannelAll = false;
      this.dataForm = {
        name: '',
        permission: {
          project_id: [],
          app_id: [],
          new_package_id: [],
          package_id: [],
          ad_group: [],
          menu: [],
          local_material_dir: []
        }
      };
      this.$nextTick(function () {
        _this2.initTree(_this2.dataForm);
      });
    },
    copyRole: function copyRole(data) {
      var _this3 = this;
      this.$prompt('输入角色名字', "\u590D\u5236 ".concat(data.name), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: data.name + '_copy'
      }).then(function (_ref) {
        var value = _ref.value;
        (0, _role.getRole)(data.id).then(function (res) {
          var _res$data$permission$, _res$data$permission$2, _res$data$permission$3;
          _this3.dataForm.name = value;
          //
          _this3.dataForm.permission.project_id = ((_res$data$permission$ = res.data.permission.projectIdAuth) === null || _res$data$permission$ === void 0 ? void 0 : _res$data$permission$.map(function (item) {
            return Number(item);
          })) || [];
          _this3.dataForm.permission.app_id = ((_res$data$permission$2 = res.data.permission.appIdAuth) === null || _res$data$permission$2 === void 0 ? void 0 : _res$data$permission$2.map(function (item) {
            return Number(item);
          })) || [];
          _this3.dataForm.permission.new_package_id = ((_res$data$permission$3 = res.data.permission.packageIdAuth) === null || _res$data$permission$3 === void 0 ? void 0 : _res$data$permission$3.map(function (item) {
            return Number(item);
          })) || [];
          //
          _this3.dataForm.permission.ad_group = res.data.permission.adGroupAuth[0] !== 'all' ? res.data.permission.adGroupAuth : ['all'];
          _this3.dataForm.permission.package_id = res.data.permission.packageIdAuth[0] !== 'all' ? res.data.permission.packageIdAuth : ['all'];
          _this3.isEdit = false;
          _this3.onSave();
        });
      });
    },
    tableEdit: function tableEdit(data) {
      var _this4 = this;
      this.isEdit = true;
      (0, _role.getRole)(data.id).then(function (res) {
        var _res$data$permission$4, _res$data$permission$5, _res$data$permission$6;
        _this4.dataForm.id = res.data.id;
        _this4.dataForm.name = res.data.name;
        //

        _this4.dataForm.permission.project_id = ((_res$data$permission$4 = res.data.permission.projectIdAuth) === null || _res$data$permission$4 === void 0 ? void 0 : _res$data$permission$4.map(function (item) {
          return Number(item);
        })) || [];
        _this4.dataForm.permission.app_id = ((_res$data$permission$5 = res.data.permission.appIdAuth) === null || _res$data$permission$5 === void 0 ? void 0 : _res$data$permission$5.map(function (item) {
          return Number(item);
        })) || [];
        _this4.dataForm.permission.new_package_id = ((_res$data$permission$6 = res.data.permission.packageIdAuth) === null || _res$data$permission$6 === void 0 ? void 0 : _res$data$permission$6.map(function (item) {
          var _res$data$permission$7;
          _this4.dataForm.permission.local_material_dir = ((_res$data$permission$7 = res.data.permission.localMaterialDirAuth) === null || _res$data$permission$7 === void 0 ? void 0 : _res$data$permission$7.map(function (item) {
            return Number(item);
          })) || [];
          if (typeof item === 'string') {
            return Number(item);
          } else {
            return item;
          }
        })) || [];
        if (res.data.permission.adGroupAuth[0] === 'all') {
          _this4.dataForm.permission.ad_group = ['all'];
          _this4.adChannelAll = true;
        } else {
          _this4.dataForm.permission.ad_group = res.data.permission.adGroupAuth;
          _this4.adChannelAll = false;
        }
        if (res.data.permission.packageIdAuth[0] === 'all') {
          _this4.dataForm.permission.package_id = ['all'];
          _this4.packageAll = true;
        } else {
          _this4.dataForm.permission.package_id = res.data.permission.packageIdAuth;
          _this4.packageAll = false;
        }
        if (res.data.permission.localMaterialDirAuth[0] === 'all') {
          _this4.dataForm.permission.local_material_dir = ['all'];
          _this4.catalogAll = true;
        } else {
          var _res$data$permission$8;
          _this4.dataForm.permission.local_material_dir = ((_res$data$permission$8 = res.data.permission.localMaterialDirAuth) === null || _res$data$permission$8 === void 0 ? void 0 : _res$data$permission$8.map(function (item) {
            return Number(item);
          })) || [];
          _this4.catalogAll = false;
        }
        _this4.dialogVisible = true;
        var resMenuList = [];
        var resMenuObj = res.data.permission.menuAuth;
        var _loop = function _loop(key) {
          if (Array.isArray(resMenuObj[key])) {
            resMenuObj[key].forEach(function (item) {
              resMenuList.push("".concat(key, "_").concat(item));
            });
          }
        };
        for (var key in resMenuObj) {
          _loop(key);
        }
        _this4.dataForm.permission.menu = resMenuList;
        _this4.$nextTick(function () {
          _this4.initTree(_this4.dataForm);
        });
      }).catch(function (err) {
        _this4.$message.error(err);
      });
    },
    checkOnClickNode: function checkOnClickNode(data) {
      if (!this.catalogAll) {
        this.dataForm.permission.local_material_dir = this.$refs.catalogTree.getCheckedNodes().map(function (item) {
          return item.id;
        });
      }
      if (!this.adChannelAll) {
        this.dataForm.permission.ad_group = this.$refs.adChannelTree.getCheckedNodes(true).map(function (item) {
          return item.id;
        });
      }
      this.dataForm.permission.menu = this.$refs.menuTree.getCheckedNodes(true).map(function (item) {
        return item.id;
      });
    },
    projectCheckboxChange: function projectCheckboxChange(project) {
      var _this5 = this;
      if (this.dataForm.permission.project_id.includes(project.id)) {
        // 选中project
        // 将所有未选中的children——app添加到dataForm.permission.app_id
        var newList = [];
        project.children.forEach(function (app) {
          if (!_this5.dataForm.permission.app_id.includes(app.app_id)) {
            newList.push(app.app_id);
          }
          // 将所有未选中的children——children——package添加到dataForm.permission.new_package_id
          var newPackageList = [];
          app.children.forEach(function (packageItem) {
            if (!_this5.dataForm.permission.new_package_id.includes(packageItem.id)) {
              newPackageList.push(packageItem.id);
            }
          });
          _this5.dataForm.permission.new_package_id = [].concat((0, _toConsumableArray2.default)(_this5.dataForm.permission.new_package_id), newPackageList);
        });
        this.dataForm.permission.app_id = [].concat((0, _toConsumableArray2.default)(this.dataForm.permission.app_id), newList);
      }
    },
    appCheckboxChange: function appCheckboxChange(app, project) {
      var _this6 = this;
      this.dataForm.permission.project_id = this.dataForm.permission.project_id.filter(function (item) {
        return item !== project.id;
      });
      if (this.dataForm.permission.app_id.includes(app.app_id)) {
        var newPackageList = [];
        app.children.forEach(function (packageItem) {
          if (!_this6.dataForm.permission.new_package_id.includes(packageItem.id)) {
            newPackageList.push(packageItem.id);
          }
        });
        this.dataForm.permission.new_package_id = [].concat((0, _toConsumableArray2.default)(this.dataForm.permission.new_package_id), newPackageList);
      }
    },
    packageCheckboxChange: function packageCheckboxChange(app, project) {
      this.dataForm.permission.project_id = this.dataForm.permission.project_id.filter(function (item) {
        return item !== project.id;
      });
      this.dataForm.permission.app_id = this.dataForm.permission.app_id.filter(function (item) {
        return item !== app.app_id;
      });
    },
    resetForm: function resetForm() {
      this.$refs['RoleForm'].resetFields();
      this.dialogVisible = false;
    },
    onSave: function onSave() {
      if (this.dataForm.name === '') {
        this.$message.error('请输入角色名称');
        return;
      }
      var deepCopyDataForm = JSON.parse(JSON.stringify(this.dataForm));
      deepCopyDataForm.permission.package_id = deepCopyDataForm.permission.new_package_id;
      delete deepCopyDataForm.permission.new_package_id;
      deepCopyDataForm.permission.menu = this.handleMenu(deepCopyDataForm.permission.menu);
      this.isEdit ? this.updateRole(deepCopyDataForm) : this.addRole(deepCopyDataForm);
      this.dialogVisible = false;
    },
    // 处理应用菜单数据传参
    handleMenu: function handleMenu(menus) {
      return menus.reduce(function (acc, item) {
        // eslint-disable-next-line no-unused-vars
        var _item$split = item.split('_'),
          _item$split2 = (0, _slicedToArray2.default)(_item$split, 2),
          init_app_id = _item$split2[0],
          init_id = _item$split2[1];
        var menuArr = menus.reduce(function (menuArr, menu) {
          var _menu$split = menu.split('_'),
            _menu$split2 = (0, _slicedToArray2.default)(_menu$split, 2),
            app_id = _menu$split2[0],
            id = _menu$split2[1];
          if (app_id === init_app_id) menuArr.push(id);
          return menuArr;
        }, []);
        acc[init_app_id] = menuArr;
        return acc;
      }, {});
    },
    toggleAllByPackage: function toggleAllByPackage() {
      if (this.packageAll) {
        this.dataForm.permission.new_package_id = ['all'];
        this.dataForm.permission.project_id = ['all'];
        this.dataForm.permission.app_id = ['all'];
      } else {
        this.dataForm.permission.new_package_id = [];
        this.dataForm.permission.project_id = [];
        this.dataForm.permission.app_id = [];
      }
    },
    /* 处理每页展示的数量改变事件 */handlePageSizeChange: function handlePageSizeChange(limit) {
      this.pagination.limit = limit;
      this.pagination.page = 1;
      // 重新加载表格数据
      this.fetchData();
    },
    /* 处理切页 */handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      // 重新加载表格数据
      this.fetchData();
    },
    switchChange: function () {
      var _switchChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(row) {
        var id, state;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              id = row.id, state = row.state;
              _context3.next = 3;
              return (0, _role.updateState)({
                id: id,
                state: state
              });
            case 3:
              this.fetchData();
              this.$message.success('修改成功');
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function switchChange(_x2) {
        return _switchChange.apply(this, arguments);
      }
      return switchChange;
    }(),
    formatCatalogData: function formatCatalogData(data) {
      var formatFn = function formatFn(list) {
        return list.map(function (item) {
          var id = item.id,
            name = item.material_name,
            _item$children = item.children,
            children = _item$children === void 0 ? [] : _item$children;
          var formattedChildren = children.length ? formatFn(children) : [];
          return {
            id: id,
            name: name,
            children: formattedChildren
          };
        });
      };
      return formatFn(data);
    },
    // 添加角色
    addRole: function addRole(deepCopyDataForm) {
      var _this7 = this;
      (0, _role.addRole)(deepCopyDataForm).then(function (res) {
        _this7.$message.success('添加成功');
        _this7.fetchData();
        return res;
      }).catch(function (err) {
        _this7.$message.error(err.msg);
        return err;
      });
    },
    // 编辑角色
    updateRole: function updateRole(deepCopyDataForm) {
      var _this8 = this;
      (0, _role.updateRole)(deepCopyDataForm).then(function (res) {
        _this8.$message.success('编辑成功');
        _this8.fetchData();
      }).catch(function (err) {
        _this8.$message.error(err.msg);
      });
    }
  }
};
exports.default = _default;